/**
 * oDIN external-processing notice.
 *
 * Informational only: dismissing it is not consent to optional processing.
 * A full registration agreement (terms, privacy, AI processing, retention…)
 * is a planned platform requirement and will supersede this notice.
 */
import React, { useState } from 'react';

// Bump when the processing described below changes materially; members
// who dismissed an older version will see the notice again.
export const ODIN_DISCLOSURE_VERSION = 3;
export const ODIN_DISCLOSURE_KEY = `midgard_odin_notice_v${ODIN_DISCLOSURE_VERSION}`;

const link = (href, label) => (
  <a href={href} target="_blank" rel="noopener noreferrer">{label}</a>
);

export default function OdinDisclosure({ onClose }) {
  const [details, setDetails] = useState(false);
  return (
    <section className="odin-disclosure" aria-label="How oDIN processes your messages">
      <div className="odin-disclosure-row">
        <span className="odin-disclosure-icon" aria-hidden="true">i</span>
        <p>
          oDIN uses external services to answer some questions.{' '}
          <button type="button" className="odin-disclosure-more" aria-expanded={details}
            onClick={() => setDetails((v) => !v)}>
            {details ? 'Hide details' : 'Details'}
          </button>
        </p>
        <button type="button" className="odin-disclosure-close" onClick={onClose}
          aria-label="Close notice" title="Close">×</button>
      </div>
      {details && (
        <ul className="odin-disclosure-details">
          <li>
            Your messages, recent conversation and the Midgard context needed to answer (such as public
            profiles, world lore or, when you ask, a short summary of your own items or account) are processed
            by {link('https://groq.com/privacy-policy/', 'Groq')} outside Midgard.
          </li>
          <li>
            For weather, places and reference questions, only a place name or a short search term is sent to
            Wikidata and {link('https://foundation.wikimedia.org/wiki/Policy:Privacy_policy', 'Wikipedia')},
            and coordinates to {link('https://www.met.no/en/About-us/privacy', 'MET Norway')}.
          </li>
          <li>
            Your Runegold balance, the time, simple weather and basic account answers are produced inside Midgard.
          </li>
          <li>Your conversations with oDIN are saved in your Records.</li>
        </ul>
      )}
    </section>
  );
}
